export default "__VITE_ASSET__6accb230__"